import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { Button, Tooltip } from '@mui/material';
import ArrowDownwardRoundedIcon from '@mui/icons-material/ArrowDownwardRounded';
import ArrowUpwardRoundedIcon from '@mui/icons-material/ArrowUpwardRounded';
import CustomMenu from '../Menu';
import SortMenuWidget from './SortMenuWidget';

const SortButton = function SortButton({
  hidden = false,
  defaultSorting = null,
  sortingOptions = [],
}) {
  const intl = useIntl();
  const [sortMenu, setSortMenu] = useState(null);
  const [currentSort, setCurrentSort] = useState(defaultSorting);

  const handleOpenSortMenu = (e) => {
    setSortMenu(e.currentTarget);
  };

  const handleCloseSortMenu = () => {
    setSortMenu(null);
  };

  useEffect(() => {
    if (defaultSorting) setCurrentSort(defaultSorting);
  }, [defaultSorting]);

  const menuOpen = Boolean(sortMenu);
  return (
    !hidden && (
      <>
        <Tooltip title={intl.messages.ORDER}>
          <Button
            variant={currentSort ? 'outlined' : 'outlined'}
            sx={{
              display: 'flex',
              alignItems: 'flex-end',
              justifyContent: 'flex-end',
              padding: '6px 8px',
              gap: '8px',
              fontSize: '13px',
              minWidth: '110px',
              color: 'greys.secondary',
              borderColor: 'greys.secondary',
            }}
            onClick={handleOpenSortMenu}
          >
            <span style={{ flexGrow: 1, whiteSpace: 'nowrap' }}>
              {
                intl.messages[
                  sortingOptions?.find(
                    ({ value }) => value === currentSort?.value
                  )?.label ?? 'ORDER'
                ]
              }
            </span>
            {currentSort?.direction === 'desc' ? (
              <ArrowDownwardRoundedIcon />
            ) : (
              <ArrowUpwardRoundedIcon />
            )}
          </Button>
        </Tooltip>
        <CustomMenu
          anchor={sortMenu}
          open={menuOpen}
          close={handleCloseSortMenu}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
        >
          <SortMenuWidget
            closeMenu={handleCloseSortMenu}
            defaultSorting={defaultSorting}
            sortingOptions={sortingOptions}
          />
        </CustomMenu>
      </>
    )
  );
};

export default SortButton;
